import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, staffOnly = false, parentOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="overline text-neutral-500">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (adminOnly && user.role !== "admin") {
    return <Navigate to={user.role === "parent" ? "/parent" : "/dashboard"} replace />;
  }
  if (staffOnly && user.role === "parent") {
    return <Navigate to="/parent" replace />;
  }
  if (parentOnly && user.role !== "parent") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
